import {useSelector, useDispatch} from 'react-redux';
import {
  selectServerData,
  selectFinancialIssuesBans,
  selectNoFinancialIssuesBans,
  selectDisplayConfig,
  selectMaxPayment,
  selectIsJetConnection,
  selectActiveJetBan,
  selectEpiData,
} from '../DebtAndUpdatePaymentBlockSlice';

export const useDebtPaymentBanSelection = () => {
  const bansList = useSelector(selectServerData); // For backward compatibility (flattened list)
  const financialIssuesBans = useSelector(selectFinancialIssuesBans);
  const noFinancialIssuesBans = useSelector(selectNoFinancialIssuesBans);
  const displayConfig = useSelector(selectDisplayConfig);
  const maxPaymentAmount = useSelector(selectMaxPayment);
  const isJetConnection = useSelector(selectIsJetConnection);
  const activeJetBan = useSelector(selectActiveJetBan);
  const epiData = useSelector(selectEpiData);

  return {
    bansList,
    financialIssuesBans,
    noFinancialIssuesBans,
    displayConfig,
    maxPaymentAmount,
    isJetConnection,
    activeJetBan,
    epiData,
  };
};
